import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {LeadRodoTerms} from "../../../lead/components/LeadRodoTerms";
import {useAppDispatch} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {setRegistrationMethodVariantB} from "../../state/registration_flow_variantB_slice";
import {AuthActionType} from "../../types/AuthActionType";
import {HiddenPriceRegisterForm} from "./HiddenPriceRegisterForm";
import {SocialAuth} from "./SocialAuth";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    onSwitchToLogin: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    title: ReactNode | string;
    gtmEventData?: () => void;
    wrapperClassName?: string;
}

const registerButtonText = "ZAŁÓŻ KONTO";

export const HiddenPriceRegisterCard = (props: IProps) => {
    const {onAuthSuccess, onSwitchToLogin, userSource, gtmSourceSection, title, gtmEventData, wrapperClassName} = props;
    const dispatch = useAppDispatch();

    const socialAuthSuccess = (authActionType: AuthActionType) => {
        dispatch(setRegistrationMethodVariantB({method: "social"}));
        onAuthSuccess(authActionType);
    };

    const emailAuthSuccess = (authActionType: AuthActionType) => {
        dispatch(setRegistrationMethodVariantB({method: "email"}));
        onAuthSuccess(authActionType);
    };

    return (
        <div className={cx(wrapperStyle, wrapperClassName)}>
            {title}

            <SocialAuth onAuthSuccess={socialAuthSuccess} userSource={userSource} gtmSourceSection={gtmSourceSection} />

            <Text align="center" className={separatorTextStyle} variant="info_txt_1">
                Lub zarejestruj się
            </Text>

            <HiddenPriceRegisterForm
                registerButtonText={registerButtonText}
                onAuthSuccess={emailAuthSuccess}
                gtmEventData={gtmEventData}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
            />

            <div className={loginSectionStyle}>
                <Text variant="info_txt_1" align="center">
                    Masz już konto?
                </Text>

                <Button onClick={onSwitchToLogin} variant="highlight_primary">
                    ZALOGUJ SIĘ
                </Button>
            </div>

            <div className={leadTermsStyle}>
                <LeadRodoTerms align="center" />
            </div>
        </div>
    );
};

const wrapperStyle = css({
    width: "100%",
    backgroundColor: "#fff",
    padding: 1.5,
    md: {
        padding: 3
    }
});

const separatorTextStyle = css({
    paddingY: 1.5,
    marginTop: 1.5,
    textAlign: "center"
});

const loginSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
    position: "relative",
    paddingTop: 3,
    paddingBottom: 1.5
});

const leadTermsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    textAlign: "center"
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {LeadRodoTerms} from "../../../lead/components/LeadRodoTerms";
import {useAppDispatch} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {setRegistrationMethodVariantB} from "../../state/registration_flow_variantB_slice";
import {AuthActionType} from "../../types/AuthActionType";
import {HiddenPriceRegisterForm} from "./HiddenPriceRegisterForm";
import {SocialAuth} from "./SocialAuth";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    onSwitchToLogin: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    title: ReactNode | string;
    gtmEventData?: () => void;
    wrapperClassName?: string;
}

const registerButtonText = "ZAŁÓŻ KONTO";

export const HiddenPriceRegisterCard = (props: IProps) => {
    const {onAuthSuccess, onSwitchToLogin, userSource, gtmSourceSection, title, gtmEventData, wrapperClassName} = props;
    const dispatch = useAppDispatch();

    const socialAuthSuccess = (authActionType: AuthActionType) => {
        dispatch(setRegistrationMethodVariantB({method: "social"}));
        onAuthSuccess(authActionType);
    };

    const emailAuthSuccess = (authActionType: AuthActionType) => {
        dispatch(setRegistrationMethodVariantB({method: "email"}));
        onAuthSuccess(authActionType);
    };

    return (
        <div className={cx(wrapperStyle, wrapperClassName)}>
            {title}

            <SocialAuth onAuthSuccess={socialAuthSuccess} userSource={userSource} gtmSourceSection={gtmSourceSection} />

            <Text align="center" className={separatorTextStyle} variant="info_txt_1">
                Lub zarejestruj się
            </Text>

            <HiddenPriceRegisterForm
                registerButtonText={registerButtonText}
                onAuthSuccess={emailAuthSuccess}
                gtmEventData={gtmEventData}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
            />

            <div className={loginSectionStyle}>
                <Text variant="info_txt_1" align="center">
                    Masz już konto?
                </Text>

                <Button onClick={onSwitchToLogin} variant="highlight_primary">
                    ZALOGUJ SIĘ
                </Button>
            </div>

            <div className={leadTermsStyle}>
                <LeadRodoTerms align="center" />
            </div>
        </div>
    );
};

const wrapperStyle = css({
    width: "100%",
    backgroundColor: "#fff",
    padding: 1.5,
    md: {
        padding: 3
    }
});

const separatorTextStyle = css({
    paddingY: 1.5,
    marginTop: 1.5,
    textAlign: "center"
});

const loginSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
    position: "relative",
    paddingTop: 3,
    paddingBottom: 1.5
});

const leadTermsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    textAlign: "center"
});
